export const SET_REMOTE_CONFIG = 'SET_REMOTE_CONFIG';

export const setRemoteConfig = (data) => {
  return {
    type: SET_REMOTE_CONFIG,
    payload: data,
  };
};